__turbopack_context__.v({
  "panel": "app-shell-module__3UYZnW__panel",
  "root": "app-shell-module__3UYZnW__root",
});
